import { TOAST_STATUS } from '@evinced-private/ui-common';

import { INotificationsContext } from '../notificationsProvider/NotificationsContext';

interface HandleRequestPayload {
	successText?: string;
	failedText?: string;
	onClose?: () => void;
	notificationsContext: INotificationsContext;
}

export const handleRequest = async (
	request: () => Promise<void>,
	{ successText, failedText, onClose, notificationsContext }: HandleRequestPayload
): Promise<void> => {
	try {
		await request();

		if (successText) {
			notificationsContext.toast({
				show: true,
				status: TOAST_STATUS.SUCCESS,
				announcement: successText
			});
		}

		onClose?.();
	} catch (error) {
		notificationsContext.toast({
			show: true,
			status: TOAST_STATUS.FAIL,
			announcement: failedText || 'Something went wrong'
		});
	}
};
